import * as Yup from 'yup';

export const emailSchema = Yup.string()
  .email('Invalid email')
  .required('Add email address. Must include an @ symbol.');
